import { createFileRoute } from "@tanstack/react-router";
import FebhTmsCoverage from "@/pages/FebhTmsCoverage";
export const Route = createFileRoute("/fehb-tms-coverage")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Fehb TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Does FEHB cover TMS and SAINT TMS? Learn about federal employee health benefits for depression treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Fehb TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Does FEHB cover TMS and SAINT TMS? Learn about federal employee health benefits for depression treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/fehb-tms-coverage",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/fehb-tms-coverage",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FebhTmsCoverage />;
}
